import styled from "styled-components";

export const StyledDiv = styled.div`
  > div {
    padding-bottom: 24px;
  }
`;
